import type { ReactNode } from "react"
import classnames from "classnames"
import { buildCurrencyScaleUnit } from "helpers/metrics/currency-scale-label"
import Row from "./row"

interface PanelColumn {
  id: string
  color: string
  label: string
  type: string | undefined
  noData: boolean | undefined
  isUnmodeled: boolean | undefined
}

interface PanelItem<TData> {
  label: string
  fn: (item: TData, type?: string) => ReactNode
  unit?: {
    currencyScale: string
    currency?: string | null
  }
}

interface CompareTablePanelProps<TData> {
  columns: PanelColumn[]
  items?: PanelItem<TData>[]
  data: TData[]
}

export default function CompareTablePanel<TData>({ items, data, columns }: CompareTablePanelProps<TData>) {
  return <div className="compare-panel fixed">
    {items?.map(({ label, fn, unit }, index) => {
      const unitLabel = unit && buildCurrencyScaleUnit(unit.currencyScale, unit.currency)
      return <div key={index} className={classnames("panel-row", { "has-unit": unit })}>
        <div className="panel-label" title={unitLabel && `${label} ${unitLabel}`}>{label}</div>
        {unitLabel && <span className="panel-unit">{unitLabel}</span>}
        {columns.map((column, columnIndex) => <Row key={columnIndex} column={column} data={data} index={columnIndex} selector={fn} />)}
      </div>
    })}
  </div>
}
